<form *ngIf="gridRegistrationForm" [formGroup]="gridRegistrationForm" formFocusable>
  <app-feedback-card [originalModel]="originalModel" [formGroup]="gridRegistrationForm"></app-feedback-card>

  <app-default-card
    [title]="'Interne Informationen'"
    *ngIf="authorizationService.hasRole('ROLE_EDITOR_BASE')"
    [info]="''">
    <app-internal-information [inputForm]="gridRegistrationForm"></app-internal-information>
  </app-default-card>

  <app-default-card
    [title]="'Anlagenstandort'"
    [info]="'Anschrift der Anlage'"
    [errorMessage]="'Anschlussadresse ist erforderlich'">
    <app-connection-object
      [areaType]="AreaTypeEnum.POWER"
      [disable]="disableAll$ | async"
      [inputForm]="gridRegistrationForm"></app-connection-object>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnehmer (Eigentümer)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person (z. B. Eigentümer), dessen Kundenanlage unmittelbar über einen Anschluss mit dem Netz des Netzbetreibers verbunden ist.'
    ">
    <app-contact-form
      [formGroup]="gridRegistrationForm.controls.customer"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiShowCustomFieldsPipe
      "></app-contact-form>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnutzer (Anlagenbetreiber)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person, die im Rahmen eines Anschlussnutzungsverhältnisses einen Anschluss an das Niederspannungsnetz zur allgemeinen Versorgung zur Entnahme oder Einspeisung von elektrischer Energie nutzt.'
    ">
    <form-row>
      <mat-checkbox
        formControlName="hasDifferentInvoiceContact"
        (change)="resetDifferingInvoiceContactForm($event.checked)">
        Ist der Anschlussnutzer abweichend vom Anschlussnehmer?
      </mat-checkbox>
    </form-row>
    <app-contact-form
      *ngIf="gridRegistrationForm.controls.hasDifferentInvoiceContact.value"
      [formGroup]="gridRegistrationForm.controls.invoiceContact"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiShowCustomFieldsPipe
      "></app-contact-form>
  </app-default-card>

  <app-default-card [title]="'Dokumente'" [info]="''">
    <app-upload-documents
      [inputFormArray]="gridRegistrationForm.controls.uploads"
      [documentTag]="'uploads'"
      [showTag]="false"
      [canUpdate]="true"
      [filterCriteria]="'equal'"
      [numberOfUploads]="10"
      [editUpload]="true"
      [showUploadButton]="true">
      <div>
        <ng-container
          *ngIf="documentsUploadInfoUIAdaptionName | uiAdaptionVisible; else defaultTechnicalDocumentsInfo">
          <div [innerHTML]="documentsUploadInfoUIAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
        </ng-container>
        <ng-template #defaultTechnicalDocumentsInfo>
          <p>
            Relevante technische Dokumentationen.
            <br />
            z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
            Übersichtsschaltplan.
            <br />
          </p>
        </ng-template>
      </div>
    </app-upload-documents>
  </app-default-card>

  <app-default-card
    [title]="'Bisheriges Messkonzept'"
    [info]="'Bitte wählen Sie hier das bereits vorhandene Messkonzept aus.'"
    [error]="
      gridRegistrationForm.controls.oldMeteringConcept.controls.id.touched &&
      gridRegistrationForm.controls.oldMeteringConcept.controls.id.hasError('required')
    "
    [errorMessage]="'Bitte wählen Sie ein Messkonzept aus.'">
    <app-grid-registration-metering-concept
      [disable]="disableAll$ | async"
      [canUpdate$]="canUpdate$"
      [catalogId]="(dataShareService.tenantConfig$ | async).gridRegistration.meteringConceptCatalogId"
      [meteringConceptFormControl]="
        gridRegistrationForm.controls.oldMeteringConcept.controls.id
      "></app-grid-registration-metering-concept>
  </app-default-card>

  <app-default-card
    [title]="'Gewünschtes Messkonzept'"
    [info]="'Bitte wählen Sie hier das von Ihnen geplante Messkonzept aus.'"
    [error]="
      gridRegistrationForm.controls.meteringConcept.controls.id.touched &&
      gridRegistrationForm.controls.meteringConcept.controls.id.hasError('required')
    "
    [errorMessage]="'Bitte wählen Sie ein Messkonzept aus.'">
    <app-grid-registration-metering-concept
      [disable]="disableAll$ | async"
      [canUpdate$]="canUpdate$"
      [catalogId]="(dataShareService.tenantConfig$ | async).gridRegistration.meteringConceptCatalogId"
      [meteringConceptFormControl]="
        gridRegistrationForm.controls.meteringConcept.controls.id
      "></app-grid-registration-metering-concept>
  </app-default-card>

  <section>
    <app-gr-meter-formpart
      [disable]="disableAll$ | async"
      [formGroup]="gridRegistrationForm"
      [hasDefiniteMeter]="true" />
  </section>

  <app-default-card [title]="'Weitere Informationen zum Netzanschluss'">
    <form-row *ngIf="(newInstalledPowerConfig$ | async) !== FieldConfigEnum.HIDDEN">
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>Anschlussleistung</mat-label>
        <input
          matInput
          type="number"
          min="0"
          [disabled]="disableAll$ | async"
          [formControl]="gridRegistrationForm.controls.newInstalledPower" />
        <span matTextSuffix>kWp</span>
      </mat-form-field>
    </form-row>
    <form-row *ngIf="(commissioningDateConfig$ | async) !== FieldConfigEnum.HIDDEN">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Datum der Inbetriebnahme</mat-label>
        <input
          matInput
          [formControl]="gridRegistrationForm.controls.commissioningDate"
          [matDatepicker]="commissioningDate" />
        <mat-datepicker-toggle matSuffix [for]="commissioningDate"></mat-datepicker-toggle>
        <mat-datepicker #commissioningDate></mat-datepicker>
      </mat-form-field>
    </form-row>
    <div fxLayout="row" fxFlexAlign="stretch">
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>Weitere Information</mat-label>
        <textarea
          matInput
          type="text"
          rows="5"
          maxlength="1024"
          [disabled]="disableAll$ | async"
          [formControl]="gridRegistrationForm.controls.comment"></textarea>
      </mat-form-field>
    </div>
  </app-default-card>

  <app-default-card [title]="'Bedingungen'" [info]="''">
    <app-hint-card [type]="'warning'" [outlined]="true">
      <ng-container
        *ngIf="
          'gridRegistration.ChangeMeteringConcept.conditionsHint' | uiAdaptionVisible$ | async;
          else noText
        ">
        <div
          [innerHTML]="
            'gridRegistration.ChangeMeteringConcept.conditionsHint' | uiAdaptionValue | safeHtmlPipe
          "></div>
      </ng-container>
      <ng-template #noText>
        <p>Der Messkonzeptwechsel muss auch im Marktstammdatenregister gemeldet werden.</p>
      </ng-template>
    </app-hint-card>
    <app-accept-conditions
      [inputForm]="gridRegistrationForm"
      [controlName]="'acceptedConditions1'"
      [inputLink]=""
      [inputText]="'Hiermit bestätige ich, dass die Zustimmung des Eigentümers vorliegt.'" />
    <form-row
      *ngIf="'gridRegistration.ChangeMeteringConcept.conditionsCheckbox' | uiAdaptionVisible$ | async">
      <mat-checkbox [formControl]="customConditionsCheckbox" [disabled]="disable">
        <div
          [innerHTML]="
            'gridRegistration.ChangeMeteringConcept.conditionsCheckbox' | uiAdaptionValue | safeHtmlPipe
          "></div>
      </mat-checkbox>
    </form-row>
    <mat-error *ngIf="customConditionsCheckbox.touched && customConditionsCheckbox.invalid">
      Bitte akzeptieren Sie alle Bedingungen
    </mat-error>
  </app-default-card>
</form>
